import React from "react";
import "./Notification.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark, faCircleInfo, faCircleCheck } from '@fortawesome/free-solid-svg-icons';

const Notification = ({ icon, text, title, titleUrl, body, layout }) => {
    const renderTitle = (variant) => {
        if (!title) {
            return null;
        }

        if (titleUrl) {
            return (
                <h3 className={`notification__title notification__title--${variant}`}>
                    <a
                        href={titleUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`notification__title-link notification__title-link--${variant}`}
                    >
                        {title}
                    </a>
                </h3>
            );
        }

        return (
            <h3 className={`notification__title notification__title--${variant}`}>{title}</h3>
        );
    };

    const renderContent = (variant) => {
        if (title || body) {
            return (
                <div className="notification__content">
                    {renderTitle(variant)}
                    {body && (
                        <p className={`notification__body notification__body--${variant}`}>
                            {body}
                        </p>
                    )}
                </div>
            );
        }

        return (
            <h3 className={`notification__text notification__text--${variant}`}>{text}</h3>
        );
    };

    switch (layout) {
        case "error":
            return (
                <div className="notification notification--error">
                    <FontAwesomeIcon
                        icon={faCircleXmark}
                        className="notification__icon notification__icon--error"
                    />
                    {renderContent("error")}
                </div>
            );

        case "info":
            return (
                <div className="notification notification--info">
                    <FontAwesomeIcon
                        icon={faCircleInfo}
                        className="notification__icon notification__icon--info"
                    />
                    {renderContent("info")}
                </div>
            );

        case "success":
            return (
                <div className="notification notification--success">
                    <FontAwesomeIcon
                        icon={faCircleCheck}
                        className="notification__icon notification__icon--success"
                    />
                    {renderContent("success")}
                </div>
            );

        default:
            return (
                <div className="notification notification--default">
                    <FontAwesomeIcon
                        icon={icon}
                        className="notification__icon notification__icon--default"
                    />
                    {renderContent("default")}
                </div>
            );
    }
};

export default Notification;